import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  AddCircleOutline,
  Delete,
  Edit,
  FlagCircle,
  RemoveCircleOutline,
  WarningAmber,
} from "@mui/icons-material";
import { useFormik, Form, FormikProvider } from "formik";
import * as yup from "yup";
import { Table } from "app/components";
import FlagIcon from "@mui/icons-material/Flag";
import EmojiFlagsIcon from "@mui/icons-material/EmojiFlags";
import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";

import {
  CASH,
  CASH_BOOK,
  CHEQUE,
  createCashChequeCreditDebitRoute,
} from "app/routes/constant";

import {
  transactionBy,
  transactionType,
} from "@jumbo/constants/transactionConst";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteEntryBook,
  editEntryBook,
  getEntryBookList,
  updateEntryBookFlag,
} from "app/redux/slice/entrybookSlice";
import moment from "moment";
import Div from "@jumbo/shared/Div";
import JumboSelectBox from "@jumbo/components/JumboSelectBox";
import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import { userType } from "app/helpers/userType";
import JumboAutoComplete from "@jumbo/components/JumboAutoComplete";
import DialogConfirm from "@jumbo/components/JumboDialog/components/DialogConfirm";
import { useSnackbar } from "notistack";
import Loader from "@jumbo/components/Loader";
import { getVendorList } from "app/redux/slice/vendorSlice";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";
import { LoadingButton } from "@mui/lab";
import { usePagination } from "app/hooks/usePagination";
import DialogDefault from "@jumbo/components/JumboDialog/components/DialogDefault";
import EditEntryBook from "../edit";
import { getExpenseTypeList } from "app/redux/slice/expenseTypeSlice";
import { getIncomeTypeList } from "app/redux/slice/incomeTypeSlice";
import RefreshIcon from "@mui/icons-material/Refresh";
import { resetFlagsApi } from "app/redux/slice/commonSlice";
const validationSchema = yup.object().shape({
  toDate: yup.date().when("fromDate", (fromDate, schema) => {
    if (fromDate) {
      return schema
        .required("To Date is required")
        .min(fromDate, "To Date cannot be before From Date");
    }
    return schema;
  }),
});
const CashAndCheque = ({ mode }) => {
  const navigate = useNavigate();
  const { cash, cheque } = transactionBy;
  const { pathname } = useLocation();
  const isCash = mode ? mode === "cash" : pathname === CASH_BOOK;
  const storagePrefix = isCash ? "cashBook" : "chequeBook";
  const { isMA } = userType();
  const dispatch = useDispatch();
  const vendorData = useSelector((state) => state?.vendor);
  const expenseTypeData = useSelector((state) => state?.expenseType);
  const incomeTypeData = useSelector((state) => state?.incomeType);
  const [showFlag, setShowFlag] = useState(false);

  const [order, setOrder] = useState(
    () => localStorage.getItem(`${storagePrefix}-order`) || "desc"
  );
  const [orderBy, setOrderBy] = useState(
    () => localStorage.getItem(`${storagePrefix}-orderBy`) || "transactionDate"
  );
  const [showDeleted, setShowDeleted] = useState(() => {
    const v = localStorage.getItem(`${storagePrefix}-showDeleted`);
    return v === "true";
  });

  const { isOpen, onClose, stageAction, actionProps } = useDisclosure();

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
    localStorage.setItem(`${storagePrefix}-order`, Order);
    localStorage.setItem(`${storagePrefix}-orderBy`, OrderBy);
  };
  const {
    isOpen: isDelete,
    onClose: closeDelete,
    actionProps: deleteActionProps,
    stageAction: deleteStageAction,
  } = useDisclosure();
  const { enqueueSnackbar } = useSnackbar();
  const entryBookData = useSelector((state) => state?.entryBook);
  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "purchaseOrder" });
  const [permissionData] = useState(
    JSON.parse(localStorage.getItem("permission"))
  );
  const [permission, setPermission] = useState({
    entryBookPermission: false,
    deletePermission: false,
    updatePermission: false,
  });
  const getPermission = () => {
    if (isMA) {
      setPermission({
        entryBookPermission: true,
        deletePermission: true,
        updatePermission: true,
      });
    } else {
      let permissionValue = {
        entryBookPermission: false,
        deletePermission: false,
        updatePermission: false,
      };
      permissionData?.length &&
        permissionData.forEach(function (num) {
          if (num?.name === "entry-book-create") {
            permissionValue.entryBookPermission = true;
          }
          if (num?.name === "entry-book-delete") {
            permissionValue.deletePermission = true;
          }
          if (num?.name === "entry-book-update") {
            permissionValue.updatePermission = true;
          }
        });
      setPermission(permissionValue);
    }
  };

  const onConfirmFlagReset = () => {
    setShowFlag(false);
    dispatch(resetFlagsApi(isCash ? "CashBook" : "ChequeBook"))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "success",
          });
          getData();
        } else {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };

  useEffect(() => {
    getPermission();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const typeData = [
    { id: "all", label: "All" },
    { id: "invoice", label: "Invoice" },
    { id: "bill", label: "Bill" },
    { id: "expense", label: "Expense" },
    { id: "party", label: "Party" },
  ];
  const handleConfirm = () => {
    dispatch(deleteEntryBook(deleteActionProps?._id))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "success",
          });
          getData();
          closeDelete();
        } else {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };

  const column = [
    {
      label: "Sr No.",
      render: (elm, i) => i + 1,
    },
    {
      id: "flag",
      label: "Flag",
      sort: false,
      align: "center",
      render: (elm) => {
        const isFlagged = elm?.flag || false;
        return (
          <IconButton
            disabled={!permission?.updatePermission}
            onClick={() => {
              const newValue = !isFlagged;
              dispatch(
                updateEntryBookFlag({ id: elm?._id, data: { flag: newValue } })
              )
                .unwrap()
                .then((res) => {
                  if (res?.status === 200) {
                    enqueueSnackbar("Flag updated successfully", {
                      variant: "success",
                    });
                    getData();
                  } else {
                    enqueueSnackbar(
                      res?.data?.responseMessage || "Update failed",
                      { variant: "error" }
                    );
                  }
                });
            }}
          >
            {isFlagged ? (
              <FlagIcon color="primary" />
            ) : (
              <EmojiFlagsIcon color="disabled" />
            )}
          </IconButton>
        );
      },
    },
    {
      id: "transactionDate",
      label: "Transaction Date",
      sort: true,
      render: (elm) => (
        <> {moment(elm?.transactionDate).format("DD/MM/YYYY")}</>
      ),
    },
    { id: "vendorName", label: "Vendor", sort: true },
    { id: "transactionType", label: "Transaction Type", sort: true },
    { id: "note", label: "Remark", sort: true },
    { id: "debitAmount", label: "Dr", sort: true },
    { id: "creditAmount", label: "Cr", sort: true },
    { id: "balance", label: "Balance" },
    {
      id: "actions",
      label: "Actions",
      sort: false,
      minWidth: 120,
      render: (elm) => (
        <>
          <IconButton
            disabled={!permission?.updatePermission}
            onClick={() => {
              dispatch(editEntryBook(elm?._id))
                .unwrap()
                .then((res) => {
                  if (res?.status === 200) {
                    stageAction(res.data.data.entryDetails);
                  } else {
                    enqueueSnackbar(res.data?.responseMessage, {
                      variant: "error",
                    });
                  }
                });
            }}
          >
            <Edit />
          </IconButton>
          <IconButton
            aria-label="delete"
            disabled={!permission?.deletePermission}
            onClick={() => {
              deleteStageAction(elm);
            }}
          >
            <Delete color={"error"} />
          </IconButton>
        </>
      ),
    },
  ];

  const deletedColumn = [
    {
      label: "Sr No.",
      render: (elm, i) => i + 1,
    },
    {
      id: "flag",
      label: "Flag",
      sort: false,
      align: "center",
      render: (elm) => {
        const isFlagged = elm?.flag || false;
        return (
          <IconButton>
            {isFlagged ? (
              <FlagIcon color="primary" />
            ) : (
              <EmojiFlagsIcon color="disabled" />
            )}
          </IconButton>
        );
      },
    },
    {
      id: "transactionDate",
      label: "Transaction Date",
      sort: true,
      render: (elm) => (
        <> {moment(elm?.transactionDate).format("DD/MM/YYYY")}</>
      ),
    },
    { id: "vendorName", label: "Vendor", sort: true },
    { id: "transactionType", label: "Transaction Type", sort: true },
    { id: "note", label: "Remark", sort: true },
    { id: "debitAmount", label: "Dr", sort: true },
    { id: "creditAmount", label: "Cr", sort: true },
  ];
  const getData = (nextValues) => {
    const currentValues = nextValues || values;
    // persist current filters
    localStorage.setItem(
      `${storagePrefix}-fromDate`,
      currentValues?.fromDate || ""
    );
    localStorage.setItem(
      `${storagePrefix}-toDate`,
      currentValues?.toDate || ""
    );
    localStorage.setItem(
      `${storagePrefix}-paymentOf`,
      currentValues?.paymentOf || "all"
    );
    localStorage.setItem(
      `${storagePrefix}-search`,
      (currentValues?.search || "").trim()
    );
    if (currentValues?.vendorId) {
      localStorage.setItem(
        `${storagePrefix}-vendorId`,
        JSON.stringify(currentValues?.vendorId)
      );
    } else {
      localStorage.removeItem(`${storagePrefix}-vendorId`);
    }
    if (currentValues?.bankId) {
      localStorage.setItem(`${storagePrefix}-bankId`, currentValues?.bankId);
    } else {
      localStorage.removeItem(`${storagePrefix}-bankId`);
    }
    localStorage.setItem(
      `${storagePrefix}-flagStatus`,
      currentValues?.flagStatus || "All"
    );
    localStorage.setItem(`${storagePrefix}-showDeleted`, String(showDeleted));
    localStorage.setItem(`${storagePrefix}-order`, order);
    localStorage.setItem(`${storagePrefix}-orderBy`, orderBy);
    const value = {
      page: page,
      perPage: rowsPerPage,
      bookType: isCash ? "cash" : "cheque",
      fromDate: currentValues?.fromDate,
      toDate: currentValues?.toDate,
      search: currentValues?.search?.trim(),
      ...(currentValues.flagStatus !== "All" && {
        flag: currentValues.flagStatus === "true",
      }),
      ...(showDeleted && { deletedAt: true }),
    };
    if (currentValues?.paymentOf !== "all") {
      value.paymentOf = currentValues?.paymentOf;
    }
    if (currentValues?.vendorId?._id) {
      value.vendorId = currentValues?.vendorId?._id;
    }
    if (currentValues?.bankId && pathname !== CASH_BOOK) {
      value.bankId = currentValues?.bankId;
    }
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    dispatch(getEntryBookList(value));
  };

  const formik = useFormik({
    initialValues: (() => {
      let vendorObj = null;
      try {
        const savedVendor = localStorage.getItem(`${storagePrefix}-vendorId`);
        vendorObj = savedVendor ? JSON.parse(savedVendor) : null;
      } catch (e) {
        vendorObj = null;
      }
      return {
        fromDate: localStorage.getItem(`${storagePrefix}-fromDate`) || "",
        toDate: localStorage.getItem(`${storagePrefix}-toDate`) || "",
        paymentOf: localStorage.getItem(`${storagePrefix}-paymentOf`) || "all",
        search: localStorage.getItem(`${storagePrefix}-search`) || "",
        vendorId: vendorObj,
        bankId: localStorage.getItem(`${storagePrefix}-bankId`) || null,
        flagStatus:
          localStorage.getItem(`${storagePrefix}-flagStatus`) || "All",
      };
    })(),
    validateOnChange: false,
    validationSchema: validationSchema,
    onSubmit: getData,
  });

  useEffect(() => {
    dispatch(getVendorList());
    dispatch(getExpenseTypeList());
    dispatch(getIncomeTypeList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, dispatch, pathname, order, orderBy, showDeleted]);

  const refresh = () => {
    // Clear all persisted filters and reset to defaults
    localStorage.removeItem(`${storagePrefix}-fromDate`);
    localStorage.removeItem(`${storagePrefix}-toDate`);
    localStorage.removeItem(`${storagePrefix}-paymentOf`);
    localStorage.removeItem(`${storagePrefix}-search`);
    localStorage.removeItem(`${storagePrefix}-vendorId`);
    localStorage.removeItem(`${storagePrefix}-bankId`);
    localStorage.removeItem(`${storagePrefix}-flagStatus`);
    localStorage.removeItem(`${storagePrefix}-showDeleted`);
    localStorage.removeItem(`${storagePrefix}-order`);
    localStorage.removeItem(`${storagePrefix}-orderBy`);

    const clearedValues = {
      fromDate: "",
      toDate: "",
      paymentOf: "all",
      search: "",
      vendorId: null,
      bankId: null,
      flagStatus: "All",
    };
    resetForm({ values: clearedValues });
    setShowDeleted(false);
    setOrder("desc");
    setOrderBy("transactionDate");
    handleChangePage(0, 0);
    getData(clearedValues);
  };

  const restoreFiltersFromStorage = () => {
    const storedFromDate =
      localStorage.getItem(`${storagePrefix}-fromDate`) || "";
    const storedToDate = localStorage.getItem(`${storagePrefix}-toDate`) || "";
    const storedPaymentOf =
      localStorage.getItem(`${storagePrefix}-paymentOf`) || "all";
    const storedSearch = localStorage.getItem(`${storagePrefix}-search`) || "";
    const storedFlagStatus =
      localStorage.getItem(`${storagePrefix}-flagStatus`) || "All";
    const storedBankId =
      localStorage.getItem(`${storagePrefix}-bankId`) || null;
    let storedVendor = null;
    try {
      const v = localStorage.getItem(`${storagePrefix}-vendorId`);
      storedVendor = v ? JSON.parse(v) : null;
    } catch (e) {
      storedVendor = null;
    }
    const savedShowDeleted = localStorage.getItem(
      `${storagePrefix}-showDeleted`
    );
    const savedOrder = localStorage.getItem(`${storagePrefix}-order`) || "desc";
    const savedOrderBy =
      localStorage.getItem(`${storagePrefix}-orderBy`) || "transactionDate";

    setShowDeleted(savedShowDeleted === "true");
    setOrder(savedOrder);
    setOrderBy(savedOrderBy);

    const restoredValues = {
      fromDate: storedFromDate,
      toDate: storedToDate,
      paymentOf: storedPaymentOf,
      search: storedSearch,
      vendorId: storedVendor,
      bankId: storedBankId,
      flagStatus: storedFlagStatus,
    };
    resetForm({ values: restoredValues });
    getData(restoredValues);
  };

  useEffect(() => {
    restoreFiltersFromStorage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, mode]);
  const { values, setFieldValue, handleSubmit, resetForm } = formik;

  return (
    <>
      {entryBookData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ display: "flex", mb: 3 }}>
            <Div sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <CardContent>
                <FormikProvider value={formik}>
                  <Form noValidate autoComplete="off">
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={2}>
                        <JumboAutoComplete
                          options={vendorData?.list ?? []}
                          label="Vendor"
                          size="small"
                          getOptionLabel={(option) => option?.name}
                          name="vendorId"
                          value={values?.vendorId}
                          onChange={(evt, value) => {
                            setFieldValue("vendorId", value);
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <JumboTextField
                          type="date"
                          label={"From Date"}
                          name="fromDate"
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          required
                          size="small"
                          value={values?.fromDate}
                        />
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <JumboTextField
                          type="date"
                          label={"To Date"}
                          name="toDate"
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          required
                          size="small"
                          value={values?.toDate}
                        />
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <JumboSelectBox
                          data={typeData}
                          id="id"
                          name={"paymentOf"}
                          size="small"
                          labelKey="label"
                          valueKey="id"
                          label="Payment Of"
                          required
                          value={values?.paymentOf}
                          onChange={(evt) =>
                            setFieldValue("paymentOf", evt.target.value)
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <FormControl fullWidth>
                          <InputLabel>Flag</InputLabel>
                          <Select
                            value={values?.flagStatus}
                            label="Flag"
                            size="small"
                            onChange={(e) =>
                              setFieldValue("flagStatus", e.target.value)
                            }
                          >
                            <MenuItem value="All">All</MenuItem>
                            <MenuItem value="true">Flagged</MenuItem>
                            <MenuItem value="false">Unflagged</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                      <Grid item xs={9} sm={1.5}>
                        <Button
                          fullWidth
                          type="submit"
                          variant="contained"
                          onClick={() => {
                            handleChangePage(0, 0);
                            handleSubmit();
                          }}
                        >
                          Submit
                        </Button>
                      </Grid>
                      <Grid item xs={3} sm={0.5}>
                        <IconButton
                          onClick={() => {
                            refresh();
                          }}
                        >
                          <RefreshIcon
                            sx={{
                              fontSize: 38,
                              marginLeft: "-22px",
                              marginTop: "-8px",
                            }}
                          />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Form>
                </FormikProvider>
              </CardContent>
            </Div>
          </Card>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <div>
                  <Typography variant={"h2"} mb={0}>
                    {isCash ? cash : cheque}{" "}
                    {`Balance = ${entryBookData?.bookBalance}`}
                  </Typography>
                </div>
                <Div sx={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="body2" sx={{ mr: 1 }}>
                    Show Deleted
                  </Typography>
                  <Switch
                    checked={showDeleted}
                    onChange={(e) => {
                      const value = e.target.checked;
                      setShowDeleted(value);
                      localStorage.setItem(
                        `${storagePrefix}-showDeleted`,
                        String(value)
                      );
                    }}
                    color="primary"
                  />
                  {permission?.updatePermission && (
                    <Tooltip title="Reset All Flags">
                      <IconButton onClick={() => setShowFlag(true)}>
                        <FlagCircle color="primary" sx={{ fontSize: 30 }} />
                      </IconButton>
                    </Tooltip>
                  )}
                  {permission?.entryBookPermission && (
                    <>
                      <LoadingButton
                        variant="contained"
                        startIcon={<RemoveCircleOutline />}
                        sx={{
                          mt: { xs: 1, md: 0 },
                        }}
                        onClick={() =>
                          navigate(
                            createCashChequeCreditDebitRoute(
                              isCash ? CASH : CHEQUE,
                              transactionType?.debit.toLocaleLowerCase()
                            )
                          )
                        }
                      >
                        Debit
                      </LoadingButton>
                      <LoadingButton
                        variant="contained"
                        sx={{
                          mt: { xs: 1, md: 0, marginLeft: "12px" },
                        }}
                        startIcon={<AddCircleOutline />}
                        onClick={() =>
                          navigate(
                            createCashChequeCreditDebitRoute(
                              isCash ? CASH : CHEQUE,
                              transactionType?.credit.toLocaleLowerCase()
                            )
                          )
                        }
                      >
                        Credit
                      </LoadingButton>
                    </>
                  )}
                </Div>
              </Stack>
              <Table
                columns={showDeleted ? deletedColumn : column}
                rows={entryBookData.list}
                count={entryBookData.total}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                OrderBy={orderBy}
                sortData={sortData}
              />
              <DialogDefault
                open={isOpen}
                onClose={onClose}
                content={
                  <EditEntryBook
                    value={actionProps}
                    onClose={onClose}
                    getData={getData}
                    expenseTypeData={expenseTypeData}
                    incomeTypeData={incomeTypeData}
                  />
                }
                title={"Update Transaction"}
                fullWidth={true}
                maxWidth={"md"}
                actions={<></>}
              />
              <DialogConfirm
                isOpen={isDelete}
                onClose={closeDelete}
                title="Are you sure you want to delete this entry book?"
                message="Are you sure you want to delete this entry book?"
                onConfirm={handleConfirm}
              />
            </CardContent>
          </Card>
          <Dialog
            open={showFlag}
            onClose={() => setShowFlag(false)}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                pb: 0,
              }}
            >
              <WarningAmber sx={{ color: "error.main", fontSize: 28 }} />
              <Typography
                variant="h6"
                component="span"
                sx={{ fontWeight: 600, color: "text.primary" }}
              >
                Reset All Flags?
              </Typography>
            </DialogTitle>

            <DialogContent sx={{ pt: 1 }}>
              <Typography variant="body1">
                This will reset all flags on this page. Do you want to continue?
              </Typography>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "flex-end", px: 3, pb: 2 }}>
              <Button
                onClick={() => setShowFlag(false)}
                variant="outlined"
                color="inherit"
              >
                Cancel
              </Button>
              <Button
                onClick={onConfirmFlagReset}
                variant="contained"
                color="error"
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </>
  );
};

export default CashAndCheque;
